module.exports = __webpack_public_path__ + "static/media/female.cb10ebc0.svg";